/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type GetStakingRewardTransactionsQueryVariables = Types.Exact<{
	filter?: Types.InputMaybe<Types.StakingHistoryFilter>;
}>;

export type GetStakingRewardTransactionsQuery = {
	__typename?: "Query";
	history: Array<{
		__typename?: "StakingAction";
		type: Types.StakingActionType;
		asset: { __typename?: "StakeableAsset"; assetId: string };
		balanceAfter: { __typename?: "CurrencyAmount"; value: string };
		assetAmount: { __typename?: "CurrencyAmount"; value: string };
		tax?: {
			__typename?: "Tax";
			fiatId: number;
			fiatAmount: { __typename?: "CurrencyAmount"; value: string };
			assetAmount: { __typename?: "CurrencyAmount"; value: string };
		} | null;
		createdAt: { __typename?: "DateTime"; iso8601: string };
	}>;
};

export const GetStakingRewardTransactionsDocument = gql`
	query getStakingRewardTransactions($filter: StakingHistoryFilter) {
		history(filter: $filter) {
			asset {
				assetId
			}
			balanceAfter {
				value
			}
			assetAmount {
				value
			}
			tax {
				fiatAmount {
					value
				}
				assetAmount {
					value
				}
				fiatId
			}
			type
			createdAt {
				iso8601
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class GetStakingRewardTransactionsGQLService extends Apollo.Query<
	GetStakingRewardTransactionsQuery,
	GetStakingRewardTransactionsQueryVariables
> {
	document = GetStakingRewardTransactionsDocument;
	client = "staking";
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
